import React, {FC, useEffect} from 'react';
import {useAction} from "../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import QuicktipLobbyComponent from "../Components/QuicktipLobbyComponent";

interface QTLProps {
    atagParams: string | null,
    mode?: string | null
    sourceParams: string | null,
    ticketOpenMode: string | null,
}
const QuicktipLobby: FC <QTLProps> = ({atagParams, mode, sourceParams, ticketOpenMode}) => {
    const {getQuicktipsData} = useAction();
    const {quicktipsData} = useTypedSelector((state) => state.quicktipsReducer);

    useEffect(()=>{
        getQuicktipsData();
    }, [])
    return (
        <>
            {
                quicktipsData.length > 0 ?
                    <QuicktipLobbyComponent mode={mode} data={quicktipsData} sourceParams={sourceParams} atagParams={atagParams} ticketOpenMode={ticketOpenMode}  />
                    : null
            }
        </>
    );

}

export default QuicktipLobby;
